import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { FONT_MAIN } from "@/pages/mobile/MobileFamiliares";

export const RESP_CHAVE = "responsabilidades-ok";

function Secao({ numero, titulo, texto, responsabilidade }) {
  return (
    <section className="mb-4">
      <p className="text-sm font-bold mb-1" style={{ color: "#c3c6d7" }}>{numero}. {titulo}</p>
      <p className="text-xs leading-relaxed" style={{ color: "#8d90a0" }}>{texto}</p>
      <p className="text-xs leading-relaxed mt-1" style={{ color: "#8d90a0" }}>
        <strong style={{ color: "#c3c6d7" }}>Responsabilidade:</strong> {responsabilidade}
      </p>
    </section>
  );
}

export function MobileResponsabilidades({ aberto, onFechar }) {
  const [concordo, setConcordo] = useState(false);

  useEffect(() => {
    if (aberto) setConcordo(!!localStorage.getItem(RESP_CHAVE));
  }, [aberto]);

  if (!aberto) return null;

  function continuar() {
    if (concordo) localStorage.setItem(RESP_CHAVE, "1");
    else localStorage.removeItem(RESP_CHAVE);
    onFechar();
  }

  return (
    <div className="fixed inset-0 z-[998] flex flex-col" style={{ background: "#11131b", fontFamily: FONT_MAIN }}
      data-testid="appmobile-responsabilidades-modal">
      <header className="flex items-center gap-3 px-4 py-3.5 border-b border-white/10">
        <h1 className="flex-1 text-base font-bold" style={{ color: "#b4c5ff" }}
          data-testid="appmobile-responsabilidades-titulo">Responsabilidades</h1>
        <button type="button" data-testid="appmobile-responsabilidades-fechar" aria-label="Fechar"
          onClick={onFechar}
          title="Fechar sem salvar"
          className="w-10 h-10 flex items-center justify-center rounded-xl active:bg-white/10"
          style={{ color: "#c3c6d7", touchAction: "manipulation" }}>
          <X className="h-5 w-5" />
        </button>
      </header>

      <main className="flex-1 overflow-y-auto px-4 py-4">
        <p className="text-xs leading-relaxed mb-4" style={{ color: "#c3c6d7" }}
          data-testid="appmobile-responsabilidades-intro">
          Para poder utilizar as funcionalidades de Acesso com QR-Code, Convites, Pré-Agenda e Acesso por voz,
          leia atentamente os termos de responsabilidade, confirme o seu compromisso e se esta de acordo com as regras de uso.
        </p>
        <Secao numero="1" titulo="Acesso com QR-Code"
          texto="O acesso ao empreendimento pode ser realizado por meio da leitura do QR Code fixado nos pontos de entrada e saída, utilizando a câmera do celular. Cada utilização é registrada e auditada pela administração."
          responsabilidade="O funcionário, titular ou seu preposto respondem civilmente por qualquer uso indevido decorrente do empréstimo do celular a terceiros ou do compartilhamento de senha de acesso ao aplicativo. Por isso, é terminantemente desaconselhado fornecer tais meios a outras pessoas." />
        <Secao numero="2" titulo="Convites"
          texto="O funcionário, titular ou seu preposto, podem cadastrar visitantes para acesso rápido, enviando um link de convite com data e hora de validade, além de dados do veículo (placa, modelo e cor)."
          responsabilidade="O funcionário, titular ou seu preposto são responsáveis pela veracidade das informações cadastradas e pelo controle do tempo de permanência do visitante autorizado." />
        <Secao numero="3" titulo="Pré-Agenda"
          texto="É possível agendar previamente a entrada de visitantes, prestadores de serviços ou fornecedores. Como os prestadores são designados pelas empresas contratadas, os dados pessoais (CPF, nome, etc.) podem não ser obrigatórios."
          responsabilidade="A autorização concedida pelo funcionário, titular ou seu preposto avalizam o acesso. Recomenda-se verificar periodicamente as agendas ativas no aplicativo, pois qualquer ocorrência relacionada ao prestador ou visitante autorizado será de responsabilidade do titular ou de seu representante." />

        <p className="text-sm font-bold mt-2 mb-1" style={{ color: "#c3c6d7" }}>Informação Importante</p>
        <ul className="text-xs leading-relaxed space-y-2 pl-4 list-disc" style={{ color: "#8d90a0" }}>
          <li>Todo cadastro e liberação de acesso são documentados e enviados por e-mail.</li>
          <li>Visitantes, prestadores e fornecedores que ingressarem no empreendimento estarão sob responsabilidade direta do funcionário, titular ou seu preposto que realizou o cadastro.</li>
          <li>Em caso de perda, roubo ou esquecimento do celular em locais públicos, deve comunicar imediatamente a administração para suspensão temporária do acesso.</li>
          <li>Em caso de dúvidas, entre em contato com a administração ou com o síndico do empreendimento.</li>
        </ul>
      </main>

      <footer className="px-4 pt-3 border-t border-white/10"
        style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))", background: "#171a26" }}>
        <p className="text-xs font-bold mb-1" style={{ color: "#c3c6d7" }}>Declaração de Concordância</p>
        <p className="text-xs leading-relaxed mb-3" style={{ color: "#8d90a0" }}>
          Estou ciente das responsabilidades civis decorrentes do uso do aplicativo e concordo integralmente com os termos acima.
        </p>
        <div className="flex items-center gap-3">
          <label className="flex flex-1 items-center gap-3 py-1" data-testid="appmobile-responsabilidades-concordo-label">
            <input type="checkbox" checked={concordo} onChange={(e) => setConcordo(e.target.checked)}
              data-testid="appmobile-responsabilidades-concordo"
              className="h-5 w-5 accent-sky-500" />
            <span className="text-sm font-semibold" style={{ color: "#e1e2ed" }}>Concordo</span>
          </label>
          <button type="button" data-testid="appmobile-responsabilidades-continuar" onClick={continuar}
            className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white active:scale-[0.98] transition-transform"
            style={{ background: "#2563EB", touchAction: "manipulation" }}>
            Continuar
          </button>
        </div>
        <p className="text-[11px] mt-1.5" style={{ color: "#8d90a0" }} data-testid="appmobile-responsabilidades-aviso">
          {concordo
            ? "Toque em Continuar para liberar QR Acesso, Convites, Pré-Agenda e Voice."
            : "Sem marcar \"Concordo\", tocar em Continuar salva que você não concorda e essas funcionalidades ficam bloqueadas."}
        </p>
      </footer>
    </div>
  );
}
